import styled from "styled-components";

import XiqBox from "../../../assets/img/PublishMenu/XiqBox.svg";
import Linkedin from "../../../assets/img/PublishMenu/Linkedin.png";
import Twitter from "../../../assets/img/PublishMenu/Twitter.png";
import Triangle from "../../../assets/img/PublishMenu/Triangle.svg";
import Html from "../../../assets/img/PublishMenu/Html.png";
import { ReactComponent as RssReactIcon } from "../../../assets/img/icons/Rss.svg";
import Workbench from "../../../assets/img/PublishMenu/Workbench.svg";
import Outlook from "../../../assets/img/PublishMenu/Outlook.svg";
import CopyIcon from "../../../assets/img/icons/copy_icon_grey.svg";
import { ReactComponent as Cross } from "../../../assets/img/icons/cross.svg";
import Rss from "../../../assets/img/PublishMenu/Rss.png";
import copy from "clipboard-copy";
import Message from "modules/Common/Components/Message";
import { getQueryCampaignId, getQueryEmailId } from "modules/EmailBrowser/utils";
import {
    exportWidgets,
    getHTMLLink,
    resetOutlookConnection,
    sendEmailWithOutlook,
    shareEmailOnSocial,
} from "modules/Publish/actions";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { API_BASE_PUBLISH } from "constants/index";
import saveAs from "file-saver";
import { generateRssFeedLink, resetRSSFeed } from "../action";
import { getSalesXGroupUsersAction, getSalesXGroupsAction, resetWidgetsPopupData } from "modules/Manage/actions";
import { useHistory } from "react-router-dom";
import { IPromoCode } from "modules/Publish/interfaces";
import ExportWidgetPopUp from "modules/Manage/Shared/ExportWidgetPopUp";
import { Collapse, Modal } from "antd";
import { RSS_FEED_MODAL_Z_INDEX } from "constants/styles";
import ButtonLeftIcon from "modules/Common/Components/ButtonLeftIcon";
import Tick from "../../../assets/img/icons/tick.svg";
interface IPublishPopupProps {
    outlookSuccessInfoMessage: boolean;
    populateSenderName: (val: string) => void
    populateSendFrom: (val: string) => void
    emailWithOutlookLoading: boolean
}

const PublishPopup: React.FC<IPublishPopupProps> = (props: IPublishPopupProps) => {
    // showing a message either error or success
    const [message, setMessage] = useState({
        status: false,
        message: "",
        type: "",
        label: "",
    });
    const { outlookSuccessInfoMessage, populateSenderName, populateSendFrom, emailWithOutlookLoading } = props;
    const history = useHistory();
    const queryParams = new URLSearchParams(window.location.search);

    // showing rss link is copied
    const [rssCopied, setRssCopied] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [promoCodes, setPromoCodes] = useState<IPromoCode[]>([]);
    const [searchedPromoCodes, setSearchedPromoCodes] = useState<IPromoCode[]>([]);
    const [showSearchePromoCodes, setShowSearchePromoCodes] = useState<boolean>(false);
    const [searchAccessCodeValue, setSearchAccessCodeValue] = useState<string>("");
    const [showOptions, setShowOptions] = useState(false);

    // getting the rss link after calling api
    const { open, load, link, success, error } = useSelector((state: RootState) => state.design.rss);
    const previewHtml = useSelector((state: RootState) => state.design.data.email_html);
    const emailType = useSelector((state: RootState) => state.editionData?.emailType.toString());
    const promoCodesLoading = useSelector((state: RootState) => state.publish.promoCodesLoading);
    const promoCodesReducer = useSelector((state: RootState) => state.publish.promoCodes);
    const isAuthorized: boolean = useSelector((state: RootState) => state.publish.isAuthorized);
    const exportWidgetPermission: boolean = useSelector(
        (state: RootState) => state.user.userData.export_widget_permission
    );
    const { first_name, last_name } = useSelector((state: RootState) => state.user.userData);

    const campaignId = getQueryCampaignId().toString();
    const emailId = getQueryEmailId().toString();

    const handleCopyHTMLtoClipboard = () => {
        // for showing copy message
        setMessage({
            status: true,
            message: "",
            type: "success",
            label: "Copied!",
        });
        copy(previewHtml);
        // for hiding copy message
        setTimeout(() => {
            setMessage({
                status: false,
                message: "",
                type: "success",
                label: "Copied!",
            });
        }, 3000);
    };

    const handleCopyHTMLLinkToClipboard = () => {
        let data = new FormData();
        data.append("email_id", getQueryEmailId().toString());
        getHTMLLink(data).then((res) => {
            const data = res.data;
            if (data.success) {
                setMessage({
                    status: true,
                    message: "",
                    type: "success",
                    label: "Copied!",
                });
                copy(`${API_BASE_PUBLISH}export_email_html_link/?email_id=${data.uuid_campaign_id}`);
                // for hiding copy message
                setTimeout(() => {
                    setMessage({
                        status: false,
                        message: "",
                        type: "success",
                        label: "Copied!",
                    });
                }, 3000);
            }
        });
    };

    // handle generated HTML
    const handleGenerateHTML = () => {
        let file = new File([previewHtml], "export.htm", {
            type: "text/plain;charset=utf-8",
        });
        saveAs(file);
    };

    // generate Rss feed API calling
    const handleGenerateRSS = () => {
        generateRssFeedLink();
    };

    // handling copy rss link
    const handleCopyRss = () => {
        copy(link);
        setRssCopied(true);
        setTimeout(() => {
            setRssCopied(false);
        }, 3000);
    };

    const emailWithOutlookHandler = () => {
        sessionStorage.removeItem("no_redirect");
        !isAuthorized && sendEmailWithOutlook(campaignId, emailId, "1", emailType);
    };

    const updatepromoCodesToBeExported = (updatedpromoCodesData: IPromoCode[]) => {
        // this function returns the ids of the promocodes that have been selected
        let checkedPromoCodeIdsHelperArray: string[] = [];
        updatedpromoCodesData.map((promoCode: IPromoCode) => {
            if (promoCode.selected === 1) checkedPromoCodeIdsHelperArray.push(promoCode.id.toString());
        });
        return checkedPromoCodeIdsHelperArray;
    };

    const showModal = () => {
        setIsModalOpen(true)
        setSearchAccessCodeValue("");
        let object: any = {};
        object.campaign_id = getQueryCampaignId();
        object.limit = 20;
        object.offset = 0;
        getSalesXGroupsAction(object);
        getSalesXGroupUsersAction(object);
        setShowSearchePromoCodes(false);
    };

    const searchPromoCodeHandler = (value: string) => {
        if (value.length > 0) {
            const searchedPromoCodes = promoCodes.filter((promoCode: IPromoCode) =>
                promoCode.name.toLowerCase().includes(value.toLowerCase())
            );
            setSearchedPromoCodes(searchedPromoCodes);
            setShowSearchePromoCodes(true);
        } else {
            setShowSearchePromoCodes(false);
        }
    };

    const onClickWorkbenchEmail = async () => {
        const name = first_name + " " + last_name;
        populateSenderName(name);
        populateSendFrom("Select Email");

        setShowOptions(false);
        resetOutlookConnection();
    };

    const onClickOutlookEmail = () => {
        setShowOptions(false);
        emailWithOutlookHandler();
    };

    useEffect(() => {
        searchPromoCodeHandler(searchAccessCodeValue);
    }, [searchAccessCodeValue]);

    useEffect(() => {
        if (promoCodesReducer.length > 0) {
            setPromoCodes(promoCodesReducer);
        }
    }, [promoCodesReducer]);
    const publishOptions = [
        {
            label: "Email with Workbench",
            icon: Workbench,
            tag: 'workbench',
            selected: !props.outlookSuccessInfoMessage,
            onClick: () => {
                if (outlookSuccessInfoMessage) {
                    onClickWorkbenchEmail();
                }
            },
        },
        {
            label: "Email with Outlook",
            icon: Outlook,
            tag: 'outlook',
            selected: props.outlookSuccessInfoMessage,
            onClick: () => {
                if (!outlookSuccessInfoMessage) {
                    onClickOutlookEmail();
                }
            },
        },
    ];
    const shareOptions = [
        // Need to show it in next sprint when linkedin sharing issue is resolved
        // {
        //     label: "Share on LinkedIn",
        //     icon: Linkedin,
        //     tag: 'linkedin',
        //     onClick: () => {
        //         shareEmailOnSocial({ emailId: getQueryEmailId(), platform: "LinkedIn" });
        //     },
        // },
        {
            label: "Export to Sales Xelerator",
            tag: 'salesx',
            icon: XiqBox,
            onClick: () => {
                showModal();
            },
        },
        {
            label: "Share on Twitter",
            icon: Twitter,
            tag: 'twitter',
            onClick: () => {
                shareEmailOnSocial({ emailId: getQueryEmailId(), platform: "Twitter" });
            },
        },
    ];
    const generateFeeds = [
        {
            label: "Copy HTML to Clipboard",
            icon: Html,
            tag: 'html-clipboard',
            onClick: () => {
                handleCopyHTMLtoClipboard();
            },
        },
        {
            label: "Copy HTML Link",
            icon: Html,
            tag: 'html-link',
            onClick: () => {
                handleCopyHTMLLinkToClipboard();
            },
        },
        {
            label: "Generate HTML file",
            tag: 'html-file',
            icon: Html,
            onClick: () => {
                handleGenerateHTML();
            },
        },
        {
            label: "Generate RSS Feed",
            tag: 'rss-feed',
            icon: Rss,
            onClick: () => {
                handleGenerateRSS();
            },
        },
    ];

    return (
        <div>
            <Wrapper>
                <div className="options-head">
                    {emailWithOutlookLoading ? <div className="empty-image" style={{ height: "35px", width: "35px" }}>
                    </div>
                        :
                        <div className="selected-img">
                            <img height="25px" width="25px" src={props?.outlookSuccessInfoMessage ? Outlook : Workbench} />
                        </div>}
                    <div>
                        {emailWithOutlookLoading ? (
                            <h4>Connecting...</h4>
                        ) : (
                            <>
                                <h4>
                                    You are sending with{" "}
                                    <strong>{props?.outlookSuccessInfoMessage ? "Outlook" : "Workbench"}</strong>
                                </h4>
                                <h5 onClick={() => setShowOptions(!showOptions)}>
                                    {showOptions ? "See less" : "See more options"}
                                    <img
                                        src={Triangle}
                                        className={`triangle-image-margin ${showOptions ? '' : 'triangle-image-up'}`}
                                        style={{ marginLeft: "5px", transform: showOptions ? "" : "rotate(180deg)" }}
                                        height="10px"
                                        width="10px"
                                    />
                                </h5>
                            </>
                        )}
                    </div>
                </div>
                <Collapse ghost bordered={false} activeKey={showOptions ? "0" : ""}>
                    <Collapse.Panel showArrow={false} key={"0"}
                        header={null}
                        children={
                            <div className="options">
                                <div className="margin-below">
                                    Publish Options:
                                    <div className="options-values">
                                        {publishOptions.map((option, index) => (
                                            <div
                                                className={`${option.selected ? "select-color" : ""} ${index % 2 === 0 ? "width55" : "width45"}`}
                                                key={index}
                                                onClick={() => option.onClick()}
                                            >
                                                <span className="margin-above">
                                                    {option.selected ? <img className="tick-image" height="15px" width="15px" src={Tick} /> :
                                                        <img height="20px" width="20px" src={option.icon} />}
                                                </span>
                                                <p>{option.label}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="margin-below">
                                    Share Options:
                                    <div className="options-values">
                                        {shareOptions.map((option, index) => (
                                            <div
                                                hidden={option.tag === 'salesx' ? emailType.toString() === "1" || !exportWidgetPermission : false}
                                                className={`${index % 2 === 0 ? "width55" : "width45"}`}
                                                key={index}
                                                onClick={() => option.onClick()}
                                            >
                                                <span className="margin-above">
                                                    <img src={option.icon} />
                                                </span>
                                                <p>{option.label}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div>
                                    Generate HTML or RSS Feed:
                                    <div className="options-values">
                                        {generateFeeds.map((option, index) => (
                                            <div
                                                className={`${index % 2 === 0 ? "width55" : "width45"}`}
                                                key={index}
                                                onClick={() => option.onClick()}
                                            >
                                                <span className={`margin-above margin-behind ${option.tag === 'rss-feed' ? 'padding-right-left' : ''}`}>
                                                    <img src={option.icon} />
                                                </span>
                                                <p>{option.label}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>} />
                </Collapse>
                {message.status && (
                    <Message type={message.type} label={message.label} message={message.message} marginTop={15} />
                )}
                {isModalOpen && (
                    <ExportWidgetPopUp
                        title="Export to Sales X"
                        subtitle="TM"
                        onClose={() => {
                            resetWidgetsPopupData();
                            setIsModalOpen(false);
                        }}
                    />
                )}
            </Wrapper>
            <Modal
                maskStyle={{ zIndex: RSS_FEED_MODAL_Z_INDEX }}
                zIndex={RSS_FEED_MODAL_Z_INDEX}
                visible={open}
                destroyOnClose={true}
                onCancel={() => {
                    resetRSSFeed();
                }}
                centered
                footer={null}
                closeIcon={<Cross />}
            >
                <ModalInnerWrapper>
                    <h1>
                        <RssReactIcon />
                        EXPORT TO RSS
                    </h1>
                    {error && (
                        <Message type={"error"} label={"Error!"} message={"Failed to Load RSS feed"} marginBottom={15} />
                    )}
                    {rssCopied && (
                        <Message
                            type={"success"}
                            label={"Copied!"}
                            message={"RSS feed link is copied to the clipboard!"}
                            marginBottom={15}
                        />
                    )}
                    {load && `Loading...`}
                    <a className="link" href={link} target="__blank">
                        {link}
                    </a>
                    <ButtonLeftIcon className={"button-top"} label="Copy" icon={CopyIcon} onClick={handleCopyRss} />
                </ModalInnerWrapper>
            </Modal>
        </div>
    );
};

export default PublishPopup;

const Wrapper = styled.div`
  background-color: #def6e6;
  border-radius: 12px;
  padding: 22px 16px 16px 16px;
  width: 100%;
  .ant-collapse-header{
    padding: 0 !important;
  }
  .ant-collapse-content-box{
    padding: 0 !important;
  }
  .options-head {
    display: flex;
    align-items: center;
    .selected-img {
      background-color: #e8ffef;
      border-radius: 25px;
      padding: 5px;
      margin-right: 8px;
    }
    .empty-image{
        height: 35px;
        width: 35px;
        background-color: #e8ffef;
        border-radius: 25px;
        margin-right: 8px;
    }
    .triangle-image-margin {
        margin-top: 2px;
        margin-left: 5px;
    }
    .triangle-image-up {
        transform: rotate(180deg);
    }
    h4 {
      font-family: "Roboto";
      font-weight: 500;
      font-size: 16px;
      color: #5e7079;
      margin-bottom: 0.2em;
    }
    h5 {
      display: flex;
      font-family: "robotoregular";
      font-weight: 700;
      font-size: 14px;
      color: #1ec252;
      margin-bottom: 0px;
      align-items: center;
      cursor: pointer;
      width: fit-content;
    }
  }
  .options {
    font-family: "Roboto Slab";
    font-weight: 700;
    font-size: 16px;
    color: #424b50;
    background-color: white;
    padding: 16px 24px;
    width: 100%;
    border: 1px solid #d8d8d8;
    border-radius: 12px;
    margin-top: 15px;
    .margin-below {
        margin-bottom: 20px;
    }
    .options-values {
        margin-top: 10px;
        display: flex;
        font-size: 14px;
        flex-wrap: wrap;
        font-family: "Roboto";
        font-weight: 500;
        color: #7e7e7e;
        line-height: 2.25;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                flex-direction: column;
            }
        p {
          margin-bottom: 0px;
          margin-left: 5px;
          cursor: pointer;
          transition: color 0.3s ease;
        }
        p:hover {
            color:#1EC252; 
        }
        .margin-above {
            margin-top:-2px;
            .tick-image {
                margin-right: 4px;
            }
        }
        .margin-behind {
            margin-left: -3px;
            padding-right: 2px;
        }
        .padding-right-left {
            padding-left: 1px;
            padding-right: 5px;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                padding-left: 3px;
                padding-right: 4px;
            }
        }
        .select-color{
            color: #1EC252;
        }
        .width45 {
            display: flex;
            width: 45%;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                width: 100%;
            }
        }
        .width55 {
            display: flex;
            width: 55%;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                width: 100%;
            }
        }
    }
  }
`;
const ModalInnerWrapper = styled.div`
  padding: 30px 50px;
  h1 {
    color: #434d69;
    font-size: 24px;
    line-height: 38px;
    font-family: "Roboto Slab", serif;
  }
  .button-top {
    margin-top: 30px;
  }
  .link {
    color: #37afe9;
    margin-bottom: 15px;
  }
  .link:hover {
    color: #ffc107;
    text-decoration: none;
  }
`;
